/* eslint-disable react/no-children-prop */
/* eslint-disable react/no-array-index-key */
/* eslint-disable sort-keys */
import React from 'react'

import { CarouselComponent, Review } from '../../components'
import useMediaQuery from '../../hooks/useMediaQuery'
import { useReviewContent } from '../../hooks/useReviewContent'
import { SectionContainer } from '../../layouts'
import { ContentParser } from '../../utils/helpers'
import {
  extraContentContainer,
  lineHeightContent,
  reviewsContainer,
  reviewsContentContainer,
  reviewsContentContainerMobile,
  reviewsHeader,
} from './ReviewsSection.module.css'

const ReviewItems = ({ isDesktop, reviews }) =>
  reviews.map((review, index) => {
    return <Review key={index} isDesktop={isDesktop} review={review} />
  })

const paginationOptions = {
  el: '.swiper-pagination',
  clickable: true,
  renderBullet(className) {
    return `<span class="${className}"></span>`
  },
}

const NewReviewsSection = ({ lang, slice }) => {
  const {
    reviewscontainerwidth,
    reviewscontent,
    reviewsheading,
    reviewskicker,
  } = slice

  const raviewData = useReviewContent()
  const localisedReviews = raviewData.filter(
    (review) => review.language.slug === lang,
  )
  const { reviewcontent } = localisedReviews[0]
  const reviews = ContentParser(reviewcontent, 'review').filter(
    (item) => item.title !== null,
  )
  const isDesktop = useMediaQuery('(min-width: 867px)')

  const reviewsContent = isDesktop ? (
    <ReviewItems isDesktop={isDesktop} reviews={reviews} />
  ) : (
    <CarouselComponent
      children={ReviewItems({ reviews, isDesktop })}
      isDesktop={isDesktop}
      pagination={paginationOptions}
    />
  )

  return (
    <SectionContainer
      containerwidth={reviewscontainerwidth}
      extraClassName={reviewsContainer}
      extraContentFontClassName={`${reviewsContainer} ${lineHeightContent}`}
      extraDescriptionClassName={extraContentContainer}
      extraHeaderClassName={reviewsHeader}
      extraHeadingClassName={reviewsContainer}
      extraHeadingContainerClassName={reviewsContentContainerMobile}
      heading={reviewsheading}
      kicker={reviewskicker}
      renderedContent={reviewscontent}
      withHeader
    >
      <div className={reviewsContentContainer}>
        {reviews.length > 0 && reviewsContent}
      </div>
    </SectionContainer>
  )
}

export default NewReviewsSection
